export default __webpack_public_path__ + "static/media/moreOptionsIcon.e571eb7d.svg";